export const overlay = document.getElementById('theme-overlay')
export const content = document.getElementById('theme-content')
export const sidebar = document.getElementById('theme-sidebar')
export const main = document.getElementById('theme-main')

export const hamburgerButton = document.getElementById('js-hamburger-button')
export const menuPrimary = document.getElementById('js-menu-primary')
export const menuParentItems = document.querySelectorAll(
	'.c-menu__link[aria-expanded]'
)
const MQ_MENU = '(min-width: 600px)'
export const mqMenu = window.matchMedia(MQ_MENU)

export const themeButtons = document.querySelectorAll(
	'#js-theme-switcher .js-theme-option'
)
export const popupToggles = document.querySelectorAll('.js-popup-toggle')
export const popups = document.querySelectorAll('.js-popup')
export const fullBleedEls = document.querySelectorAll('.u-full-bleed')
